<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="分站列表" style="height:auto" >
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="brandForm" class="demo-form-inline">
          <el-form-item label="分站名称">
            <el-input size="mini" v-model.trim="brandForm.brandName" placeholder="分站名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top:16px;">
        <el-table
          :data="data" border>
          <el-table-column
            fixed
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="brandName"
            label="品牌英文名称"
            width="110">
          </el-table-column>
          <el-table-column
            prop="brandCnName"
            label="品牌中文名称"
            width="110">
          </el-table-column>
          <el-table-column
            prop="imageWebsite"
            label="品牌图片域名"
            show-overflow-tooltip
            width="150">
          </el-table-column>
          <el-table-column
            prop="baseWebsite"
            width="180"
            show-overflow-tooltip
            label="品牌域名">
          </el-table-column>
          <el-table-column
            prop="recordNumber"
            width="170"
            label="备案号">
          </el-table-column>
          <el-table-column
            prop="brandDetail"
            show-overflow-tooltip
            label="品牌介绍">
          </el-table-column>
          <el-table-column
            prop="createDate"
            width="160"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleShowEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <el-dialog title="编辑站点信息" :visible.sync="isShow" :close-on-click-modal="false">
      <el-form :model="websiteConfigForm" label-width="120px" size="mini">
        <el-form-item label="品牌站点">
          <el-input v-model="websiteConfigForm.brandName" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider>首页TDK配置</el-divider>
        <el-form-item label="title">
          <el-input v-model="websiteConfigForm.mainConfig.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="keyword">
          <el-input v-model="websiteConfigForm.mainConfig.keyword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="description">
          <el-input v-model="websiteConfigForm.mainConfig.describe" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider>品牌页TDK配置</el-divider>
        <el-form-item label="title">
          <el-input v-model="websiteConfigForm.brandConfig.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="keyword">
          <el-input v-model="websiteConfigForm.brandConfig.keyword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="description">
          <el-input v-model="websiteConfigForm.brandConfig.describe" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider>品牌分类页TDK配置</el-divider>
        <el-form-item label="title">
          <el-input v-model="websiteConfigForm.cateConfig.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="keyword">
          <el-input v-model="websiteConfigForm.cateConfig.keyword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="description">
          <el-input v-model="websiteConfigForm.cateConfig.describe" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="备案号">
          <el-input v-model="websiteConfigForm.recordNumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="品牌介绍">
          <el-input v-model="websiteConfigForm.brandDetail" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="isShow = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="handleEdit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      isShow: false,
      brandForm: {
        brandName: '',
        token: this.user.getToken()
      },
      websiteConfigForm: {
        id: '',
        brandName: '',
        brandCnName: '',
        mainConfig: {},
        brandConfig: {},
        cateConfig: {},
        recordNumber: '',
        titleMl: '',
        titleSn: '',
        titleCn: '',
        brandDetail: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  methods: {
    handleShowEdit(row) {
      this.isShow = true
      this.websiteConfigForm.id = row.id
      this.websiteConfigForm.brandName = row.brandName
      this.websiteConfigForm.mainConfig = row.mainConfig
      this.websiteConfigForm.brandConfig = row.brandConfig
      this.websiteConfigForm.cateConfig = row.cateConfig
      this.websiteConfigForm.recordNumber = row.recordNumber
      this.websiteConfigForm.brandDetail = row.brandDetail
      this.websiteConfigForm.brandCnName = row.brandCnName
    },
    handleEdit: function() {
      this.websiteConfigForm.titleMl = this.websiteConfigForm.mainConfig.title +'#' + this.websiteConfigForm.mainConfig.keyword +'#' + this.websiteConfigForm.mainConfig.describe
      this.websiteConfigForm.titleSn = this.websiteConfigForm.brandConfig.title +'#' + this.websiteConfigForm.brandConfig.keyword +'#' + this.websiteConfigForm.brandConfig.describe
      this.websiteConfigForm.titleCn = this.websiteConfigForm.cateConfig.title +'#' + this.websiteConfigForm.cateConfig.keyword +'#' + this.websiteConfigForm.cateConfig.describe
      // 初始化默认加载菜单
      this.http.post(
        '/brand/config/modify',
        this.websiteConfigForm, res => {
          if (res.success) {
            // 返回正确的处理
            this.$message({
              message: '站点配置修改成功',
              type: 'success'
            });
            this.getData()
            this.isShow = false
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    getData: function() {
      this.optionItem = this.common.extend(this.brandForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/brand/config/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getData()
    }
  },
  mounted: function() {
    this.getData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/config/website.vue